import styled from "styled-components";
import React, { useRef } from "react";
import { PodEpisodes } from "../../assets/Podcast/PodEpisodes";
import { Link } from "react-router-dom";
import { Edit } from "../../assets/Menu/Edit";
import { gql, useQuery } from "@apollo/client";
import { Loading } from "../../components/Loading";
import PersonalDataShow from "../../components/forms/PersonalDataShow";
import ResumeDataShow from "../../components/forms/ResumeDataShow";
import ResumeDataEdit from "../../components/forms/ResumeDataEdit";
import { Printer } from "../../assets/Menu/Printer";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import { PodResume } from "../../assets/Podcast/PodResume";

const StyleCss = styled.div`
  padding: 0 0 1rem 0;
  .content {
    @media print {
      @page {
        size: 210mm 297mm;
      }
    }
  }
`;

export const Resume_Query = gql`
  query ResumeQuery{
    getResume{
        _id
        User
        Name
        Position
        Image
        Email
        Mobile
        Province
        Address
        Maried
        BirthYear
        Gender
        Military
        Job
        Description
        DescriptionJob
        image
        JobBack {
          JobTitle
          companyName
          InDate
          OutDate
          Working
        }
        EduBack {
          EduTitle
          Where
          EduName
          InDate
          OutDate
        }
        LanBack {
            LanTitle
            Level
        }
        booleans {
          Name
          Image
          Email
          Mobile
          Province
          Address
          Maried
          BirthYear
          Gender
          Military
          Job
          Description
          DescriptionJob
          image
          JobBack
          EduBack
          LanBack
        }
    }
  }
`;

function WorkPageResume(props) {
  const componentRef = useRef()
  const print = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "resume",
  })
  const resume = useQuery(Resume_Query, {
    fetchPolicy: "network-only"
  });
  if(resume.loading){
    return (
      <StyleCss className="main-box">
        <div className="title-bar">
          <div className="title">
            <div className="icon"><PodResume/></div>
            <div className="text">Resume</div>
          </div>
          <Link to={'/work/resume/edit'} className="action"><Edit/></Link>
        </div>
        <div className="content">
          <Loading/>
        </div>
      </StyleCss>
    )
  }
  // get resume
  // default form
  let data = (
    <ResumeDataShow {...props} resume={resume.data.getResume}/>
  )
  let link = (
    <>
    <div className="action" onClick={print}><Printer/></div>
    <Link to={'/work/resume/edit'} className="action"><Edit/></Link>
    </>
  )

  if(props.match.params.edit === 'edit'){
    // host edit
    data = (
      <ResumeDataEdit {...props} resume={resume.data.getResume}/>
    )
    link = ''
  }
  return (
    <StyleCss className="main-box">
      <div className="title-bar">
          <div className="title">
            <div className="icon"><PodResume/></div>
            <div className="text">Resume</div>
          </div>
          <div className="expand"></div>
          {link}
      </div>
      <div className="content" ref={componentRef}>
        {data}
      </div>
    </StyleCss>
  )
}
export default WorkPageResume;